export default __webpack_public_path__ + "static/media/tick.b03166e0.svg";